
import { cartGet, cartAdd, cartGetCurrent, cartUpdate, cartChange } from '@process-creative/slate-theme-tools';
import { CustomiserColor } from './customiser-color';
import { CLASS_DISABLED } from "../tools/constants/classes";

export const CLASS_OPEN = 'is-bundle-builder-open';

const SELECTOR_COLOR_TITLE = '[data-color-title]';
const SELECTOR_SAMPLE_BUTTON = '[data-sample-add]';
const SELECTOR_SAMPLE_LABEL = '[data-sample-add-text]';

const ATTR_SAMPLE_VARIANT_ID = 'data-sample-variant-id';

const getColorPickerMarkup = () => {
  const template = document.createElement('template');
  template.innerHTML = `
    <style>
      :host {
        display: block;
        margin-left: -1.25rem;
        margin-right: -1.25rem;
        width: calc(100% + 2.5rem);
        position: relative;
      }

      :root {
        display: flex;
        width: 100%;
      }

      .option-picker {
        width: 100%;
      }

      slot {
        display: block;
        width: 100%;
        overflow-x: auto;
        overflow-y: visible;
        white-space: wrap;
      }

      slot::-webkit-scrollbar {
          display: none;
      }

      ::slotted(fieldset) {
        display: inline-flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: .4375rem;
        border: none;
        margin: 0;
        padding: 0 1.25rem;
        overflow: visible;
      }

      .title-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1.25rem;
      }
      
      .title-wrapper h3 {
        font-weight: 500;
        font-size: 14px;
      }

      [data-color-title] {
        color: rgba(22, 48, 33, 0.30);
      }

      .sample-button {
        position: relative;
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
        padding: 8px 15px;
        margin: 24px auto 0;
        font-size: 14px;
        font-family: 'TTNorms Font', Helvectica, sans-serif;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        background-color: #F1EBE7;
      }
      
      .sample-button span {
        color: #163021;
      }

      .sample-button.is-disabled [data-sample-add-text] {
        opacity: 0.5;
        cursor: not-allowed;    
      }

      .sample-button [data-sample-disable-message] {
        display: none;
        position: absolute;
        top: -100%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        width: 200%;
        background-color: white;
        padding: 1rem;
        border-radius: 3px;
      }

      .sample-button.is-disabled:hover [data-sample-disable-message] {
        display: block;
      }

      .sample-button svg {
        width: 18px;
        height: 18px;
      }

      @media only screen and (min-width: 450px) {
        .title-wrapper,
        .title-wrapper h3 {
          font-size: 1rem;
          line-height: 1.75rem;
        }
      }

      @media only screen and (min-width: 395px) {
        ::slotted(fieldset) {
          margin-left: auto;
          margin-right: auto;
          overflow: visible;
        }

        .title-wrapper {
          justify-content: center;
        }
      }

      @media only screen and (min-width: 1100px) {

        :host {
          margin-left: 0;
          margin-right: 0;
          width: 100%;
          overflow: visible;
        }

        ::slotted(fieldset) {
          gap: .5rem;
          flex-wrap: wrap;
          margin-left: 0;
          margin-right: 0;
          padding: 0;
          justify-content: flex-start;
        }

        slot {
          overflow: visible;
        }

        .title-wrapper {
          padding: 0;
          justify-content: flex-start;
        }
          

        .title-wrapper h3 {
          margin-top: 0;
          margin-bottom: 1.3125rem;
        }
        
        .sample-button {
          margin: 40px 0 0 0;
          font-size: 1rem;
          line-height: 24px;
          padding: .5rem 1rem;
          gap: 6px;
          transition: all 500ms;
        }

        .sample-button:hover svg circle {
          fill: #163021;
        }

        .sample-button:hover svg path {
          stroke: #fff;
        }
      }

      @media only screen and (min-width: 1750px) {

        .sample-button {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }

        .sample-button svg {
          width: 20px;
          height: 20px;
        }
      }
    </style>

    <div class="color-picker-wrapper">
      <div class="title-wrapper">
        <h3>
          <span>Colour:</span>
          <span data-color-title></span>
        </h3>

      </div>
      <slot></slot>
    </div>
    

    <button
      class="sample-button o-btn is-tertiary has-icon"
      data-sample-add
    > 
      <span data-sample-disable-message></span>
      <span data-sample-add-text>Add sample</span>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><g stroke="#163021"><circle cx="10" cy="10" r="7.5"/><path stroke-linecap="round" d="M6.667 10h6.666M10 6.667v6.666"/></g></svg>
    </button>
    `;
  
  return template;
}

export class CustomiserColorPicker extends HTMLElement {
  private options:CustomiserColor[]|[] = [];
  private addSampleBtn:HTMLElement | null | undefined = null;
  private addSampleBtnText:HTMLElement | null | undefined = null;
  private colorTitle:HTMLElement | null | undefined = null;
  private step_id: string = this.getAttribute('step-id');
  private sampleDisableText;

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getColorPickerMarkup();
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.options = [...this.querySelectorAll('customiser-color')];
    
    if (!this.options.length) {
      console.error('You need to render some options in here!', this);
      // return;
    }
    
    this.colorTitle = this.shadowRoot?.querySelector(SELECTOR_COLOR_TITLE);
    this.addSampleBtn = this.shadowRoot?.querySelector(SELECTOR_SAMPLE_BUTTON)!;
    this.addSampleBtnText = this.shadowRoot?.querySelector(SELECTOR_SAMPLE_LABEL)!;

    this.sampleDisableText = this.shadowRoot?.querySelector('[data-sample-disable-message]');

    this.addSampleBtn.addEventListener('click', (e) => {
      this.handleAddSampleClick(e);
    });

  }

  setOption(colorOption:any) {
    if (this.colorTitle && colorOption.option_title) {
      const colorNameSplit = colorOption.option_title.split('-');
      this.colorTitle.innerHTML = colorNameSplit[colorNameSplit.length - 1];
    }

    if (this.addSampleBtn) {
      this.addSampleBtn.setAttribute(ATTR_SAMPLE_VARIANT_ID, colorOption.sample_variant_id);

      if (colorOption.sample_variant_availability && colorOption.sample_variant_id) {
        this.addSampleBtn.classList.remove(CLASS_DISABLED);
      } else {
        // console.log('DISABLE SAMPLE', colorOption)
        this.addSampleBtn.classList.add(CLASS_DISABLED);
        this.sampleDisableText.textContent = colorOption.sample_disable_message;
      }
    }
    this.options.forEach(option => option.setSelected(option.option_id === colorOption.option_id));
  }

  public setStepId(id:string) {
    // This function is implemented in multiple spots.
    // If changing it here, update the otehr locations
    this.step_id = id;
    const componenentsWithStepId = this.querySelectorAll('[step-id]');

    componenentsWithStepId.forEach(component => component?.setStepId(id))
  }

  public getOptionById(optionId:string) {
    return this.options.find(option => option.option_id === optionId)
  }

  get selectedOptions() {
    return this.options.find(opt => opt.isSelected)
  }

  handleAddSampleClick(e:Event) {
    if (this.addSampleBtn?.classList.contains('is-disabled')) return;
    const sampleVariantID = this.addSampleBtn?.getAttribute(ATTR_SAMPLE_VARIANT_ID);
    if (sampleVariantID != 'null') this.addItemToCart(sampleVariantID);
  }

  async addItemToCart(variantID:string) {
    let orginalText = this.addSampleBtn?.innerText;
    
    if (!variantID) return;

    if (this.addSampleBtn && this.addSampleBtnText) {
      this.addSampleBtn.setAttribute('disabled', 'disabled');
      this.addSampleBtnText.innerText = 'Adding...'
    }

    try {
      await cartAdd({
        items: [{
          id: parseInt(variantID),
          quantity: 1
        }]
      });

      setTimeout(() => {
        if (this.addSampleBtnText && orginalText) {
          this.addSampleBtnText.innerText = 'Added'
        }
      }, 500);
      
      setTimeout(() => {
        if (this.addSampleBtnText && this.addSampleBtn && orginalText) {
          this.addSampleBtn.removeAttribute('disabled');
          this.addSampleBtnText.innerText = orginalText
        }
      }, 1500);
    } catch (e) {
      console.error('Failed to add to cart.');
      return;
    }
  }

  setSelectedColor(variant_id) {
    const selected_option = this.options.find(item => variant_id === String(item.variant_id));
    selected_option?.handleChange();
  }

  get firstAvailableOption() {
    return this.options.find(option => !option.disable_for_product);
  }

  reset() {
    // Get the first AVAILABLE option and click it
    this.firstAvailableOption?.handleChange(); 
  }
}

if (!customElements.get('customiser-color-picker')) {
  customElements.define('customiser-color-picker', CustomiserColorPicker);
}